import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import TableHeader from "../../../../components/Tables/TableHeader";
import { Link } from "react-router-dom";
import { AgenciesArray } from "../../arrays/AgenciesArray";
import getNameByID from "../../../../../functions/getNameByID";
import { Get_limited_Choose_Fields_From_MongoDB } from "../../../../api/Get_limited_Choose_Fields_From_MongoDB";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function TableOfViewAgencies({ Agencies }) {
  const { logout } = StaffuseAuth();

  //The below gets the staff
  const [Staff, setStaff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_From_MongoDB(
      "Staff",
      "Users",
      100,
      setStaff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  //Filter the staff for IP's
  let IPStaff = Staff.filter((prop) =>
    prop.Team.toLowerCase().includes("ip".toLowerCase())
  );

  //-----------------------------Begin Sorting---------------------------------------------
  // Assuming the rest of your component is defined here
  const [sortField, setSortField] = useState("Rating"); // Default sort by 'Text'
  const [sortDirection, setSortDirection] = useState("desc"); // 'asc' or 'desc'

  // Function To sort table
  const sortArray = (Agencies, field, direction) => {
    return Agencies.sort((a, b) => {
      if (a[field] < b[field]) return direction === "asc" ? -1 : 1;
      if (a[field] > b[field]) return direction === "asc" ? 1 : -1;
      return 0;
    });
  };

  //-----------------------------Sorting---------------------------------------------

  // Sort table when sortField or sortDirection changes
  const sortedAgencies = sortArray([...Agencies], sortField, sortDirection);

  // Function To handle header click
  const handleHeaderClick = (field) => {
    if (field === sortField) {
      // Toggle sort direction
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc"); // Default To ascending when changing sort field
    }
  };

  let usearray = [
    { Name: "Name", Field: "Name" },
    { Name: "Email", Field: "Email" },
    { Name: "Country", Field: "Country" },
    { Name: "PostCode", Field: "PostCode" },
    { Name: "Address", Field: "Address" },
    { Name: "VAT Number", Field: "VAT_Number" },
    { Name: "CRN", Field: "CRN" },
    { Name: "Phone", Field: "Phone" },
    { Name: "Tax Code", Field: "Tax_Code" },
  ];
  //-----------------------------Return---------------------------------------------

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "95%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        View Agencies
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              {TableHeader("IP", handleHeaderClick, "IP_id")}

              <>{TableHeader("Name", handleHeaderClick, "Name")}</>
              <>{TableHeader("Email", handleHeaderClick, "Email")}</>
              <>{TableHeader("Country", handleHeaderClick, "Country")}</>
              <>{TableHeader("City", handleHeaderClick, "City")}</>
              <>{TableHeader("Address", handleHeaderClick, "Address")}</>
              <>{TableHeader("PostCode", handleHeaderClick, "PostCode")}</>
              <>{TableHeader("Phone", handleHeaderClick, "Phone")}</>
              <>{TableHeader("View", handleHeaderClick, "Name")}</>
              <>{TableHeader("Add EC", handleHeaderClick, "Name")}</>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedAgencies.map((Agency, index) => (
              <TableRow
                key={Agency._id}
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                    "& .MuiTableCell-root": {
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word", // Adjust padding here to make cells smaller
                    },
                  },
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {getNameByID(IPStaff, Agency.MetaData.IP_id, "Username")}
                </TableCell>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Agency.BasicInfo["Name"]}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Agency.BasicInfo["Email"]}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Agency.BasicInfo["Country"]}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Agency.BasicInfo["City"]}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Agency.BasicInfo["Address"]}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Agency.BasicInfo["PostCode"]}
                  </TableCell>
                </>

                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Agency.BasicInfo["Phone"]}
                  </TableCell>
                </>

                {/* New TableCell for update action using Link */}
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <Link
                    to={`/Staff/ViewAgency/${Agency._id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <button>View</button>
                  </Link>
                </TableCell>
                {/* New TableCell for add event action using Link */}
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <Link
                    to={`/Staff/ViewEC/AddEC/${Agency._id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <button>Add EC</button>
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TableOfViewAgencies;
